module.exports = "//static.hsappstatic.net/ContentComponents/static-2.67510/img/DeepL-logo.png"